// utils/styleUtils.js
export const styleUtils = {
    getContainerClasses: (variant, className, disableRTL = false) => {
        const baseClass = "order-items-list";
        const variantClass = `order-items-${variant}`;
        const rtlClass = disableRTL ? "disable-rtl" : "";
        return `${baseClass} ${variantClass} ${rtlClass} ${className}`.trim();
    },

    getItemClasses: (variant, onItemClick, hasDiscount) => {
        return `order-item ${variant}-item ${onItemClick ? "clickable" : ""
            } `;
    }
};